<template>
	<!-- <input
        v-model="bufferValue"
        type="number"
        class="form-control outline-secondary"
        :placeholder="placeholder"
        @blur = "handlerBlur"
        step="0.01"
        min="0"
        pattern="^\d*(\[.,]\d{0,2})?$"
    > -->
	<input
		class="form-control"
		v-model="bufferValue"
		type="number"
		:placeholder="placeholder"
		@blur="handlerBlur"
		onwheel="return false;"
		
	/>
</template>

<script>
	export default {
		name: 'ReUsefulSquare',
		components: {

		},
		props: {
			value: [String,Number], //String, //[String,Number]
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: {
				type: String,
				default: '',
			},
			externalVal: Number,
			externalParamsValue:{
                type: Object,
                default(){ return {}; },
            },
		},
		data () {
			return {
				ver: 1,
				bufferValue:'',
                changed: false,
			}
		},
		watch:{
			value(val){
				// console.log('value',val);
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){  
				// console.log('bufferValue',val);
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
                this.changed = true;
			},
			externalParamsValue:{
				// магия получения параметров из других компонентов формпринтера
                handler(value){
                    this.prepareData();
					// this.textT;
					//console.log('externalParamsValue',value);
                },
                deep: true,
            },
		},
		computed: {

		},
		methods: {
            handlerBlur(event){
                if(!this.changed) return;
                let val = this.bufferValue;
				// if(typeof val == 'number') val = val.toString();
				val = String(val).replace(',','.');
				if(val<0){
					val = val * -1; //дедлаем значение положительным
				}
				// //let number1 = this.$GVO.number_format(val,0,'.',' ');
                // let number1 = parseFloat(val).toFixed(2);
				// if(number1 == 0 ){ number1= ''; }
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
                this.changed=false;     
				// console.log(this.changed); 
            },
			prepareData(){ 
				// магия получения параметров из других компонентов формпринтера + запись части данных в текстовый шаблон.
				if(!this.externalParamsValue) return;
				if(this.externalParamsValue.chambers.roomSum){
					try{
                        this.bufferValue = this.externalParamsValue.chambers.roomSum;
                    }catch(e){}
				}
				
			},
			// fixNumber(element){
			// 	// меняем в числах запятую на точку.
			// 	element.element_model = String(element.element_model).replace(',','.');
			// },			
		},
		mounted() {
			this.bufferValue = this.value;
		}
	}
</script>
<style scoped>

</style>
